// Modal as a separate component
import React, { MutableRefObject, ReactEventHandler, useEffect, useRef } from 'react';
import styles from './styles/Dialog.module.scss';

type DialogProps = {
  openModal: boolean;
  closeModal: ReactEventHandler<HTMLDialogElement>;
  children: React.JSX.Element | React.JSX.Element[];
  rounded?: boolean;
};

const Dialog: React.FunctionComponent<DialogProps> = (props: DialogProps) => {
  const { openModal, closeModal, children, rounded } = props;

  // @ts-ignore
  const ref: MutableRefObject<HTMLDialogElement> = useRef();

  useEffect(() => {
    if (openModal) {
      ref.current.showModal();
    } else {
      ref.current.close();
    }
  }, [openModal]);

  return (
    <dialog className={`${styles.modal} ${rounded ? styles.rounded : undefined}`} ref={ref} onCancel={closeModal}>
      {children}
    </dialog>
  );
};

export default Dialog;
